import AppState from 'AppState';
import * as React from 'react';
import { EntityDefinition } from 'types';
import HelpSVG from '../svg/HelpSVG';

interface ListingHelpButtonProps {
	entityDefinition: EntityDefinition;
	containerClassNames?: string;
	linkClassNames?: string;
	iconClassNames?: string;
}

/**
 * Help button to be display on the listing and edit page
 */
function ListingHelpButton(props: ListingHelpButtonProps) {
	const { entityDefinition, linkClassNames, containerClassNames, iconClassNames } = props;

	if (entityDefinition.documentUrlKey == null) {
		return null;
	}

	const helpUrl = AppState.documentUrls[entityDefinition.documentUrlKey];

	if (helpUrl == null || helpUrl === '') {
		return null;
	}

	const linkText = `View documentation for ${entityDefinition.pluralName}`;

	return (
		<div className={containerClassNames}>
			<a
				href={helpUrl}
				className={linkClassNames}
				target="_blank"
				rel="noopener noreferrer"
				data-testid="view-docs-btn"
				aria-label={`${linkText} opens in a new window`}
			>
				<HelpSVG class={iconClassNames} />
			</a>
		</div>
	);
}

export default ListingHelpButton;
